import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ActionModal } from "@components";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string | React.ReactNode;
}

export const ActionRetryModal: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  description,
}) => {
  const navigate = useNavigate();

  const handleVolverAlInicio = useCallback(() => {
    onClose();
    navigate("/app/solicitudes");
  }, [onClose, navigate]);

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      description={description}
      secondaryButton={{
        label: "Volver al inicio",
        onClick: handleVolverAlInicio,
      }}
      primaryButton={{
        label: "Reintentar",
        onClick: onClose,
      }}
    />
  );
};
